module.exports = __webpack_public_path__ + "img/_brazil.a6f46ee1.png";